import React from "react";
import { hasPowFeature } from "../services/powFeatures.service";

interface PowFeatureProps {
	// feature to check
	feature: string;
	// render function to call with fetched data
	children: JSX.Element;
}

/**
 * Will render the child components only if user has access to pow feature
 */
export const PowFeature = ({ feature, children }: PowFeatureProps) => <>{hasPowFeature(feature) ? children : null}</>;
